export default __webpack_public_path__ + "src/assets/credits-opensea.1cd8fbf813960a338594045132f010a8.svg";